import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Link,
  Navigate,
} from "react-router-dom";
import RegistroCliente from "./components/Cliente/RegistroCliente";
import ListaClientes from "./components/Cliente/ListaClientes";
import RegistroReserva from "./components/Reserva/RegistroReserva";
import ListadoReservas from "./components/Reserva/ListadoReservas";
import Calendario from "./components/Calendario/Calendario";
import CalendarioReactCalendar from "./components/Calendario/CalendarioReactCalendar";
import Dashboard from "./components/Dashboard/DashboardPrincipal";
import ListaApartamentos from "./components/Apartamento/ListaApartamentos";
import Login from "./components/Login/Login";
import Swal from "sweetalert2";

Modal.setAppElement("#root");

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(
    localStorage.getItem("isAuthenticated") === "true"
  );
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLogin = () => {
    setIsAuthenticated(true);
    localStorage.setItem("isAuthenticated", "true");
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem("isAuthenticated");
    Swal.fire("Sesión Cerrada", "Has cerrado sesión correctamente", "info");
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    const authStatus = localStorage.getItem("isAuthenticated");
    setIsAuthenticated(authStatus === "true");
  }, []);

  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        {isAuthenticated ? (
          <>
            <nav className="bg-gray-800 text-white p-4 flex justify-between items-center">
              <h1 className="text-2xl font-bold">Gestión Posada</h1>
              <div className="md:hidden">
                <button
                  onClick={toggleMenu}
                  className="p-2 bg-gray-700 rounded hover:bg-gray-600 transition"
                >
                  <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M4 6h16M4 12h16M4 18h16"
                    ></path>
                  </svg>
                </button>
              </div>
              <div
                className={`md:flex items-center space-x-4 ${
                  isMenuOpen ? "block" : "hidden"
                } md:block`}
              >
                <NavLink to="/dashboard" label="Dashboard" />
                <NavLink to="/clientes/registro" label="Registrar Cliente" />
                <NavLink to="/clientes" label="Listado de Clientes" />
                <NavLink to="/reservas/registro" label="Registrar Reserva" />
                <NavLink to="/reservas" label="Listado de Reservas" />
                <NavLink to="/apartamentos" label="Apartamentos" />
                <NavLink to="/calendario" label="Calendario" />
                <button
                  onClick={handleLogout}
                  className="p-2 bg-red-500 rounded hover:bg-red-600 transition"
                >
                  Cerrar Sesión
                </button>
              </div>
            </nav>

            <div className="flex-1 p-6 bg-gray-100">
              <Routes>
                <Route path="/" element={<Navigate to="/dashboard" />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/clientes" element={<ListaClientes />} />
                <Route
                  path="/clientes/registro"
                  element={<RegistroCliente />}
                />
                <Route path="/reservas" element={<ListadoReservas />} />
                <Route
                  path="/reservas/registro"
                  element={<RegistroReserva />}
                />
                {/* <Route path="/calendario" element={<Calendario />} /> */}
                <Route
                  path="/calendario"
                  element={<CalendarioReactCalendar />}
                />
                <Route path="/apartamentos" element={<ListaApartamentos />} />
              </Routes>
            </div>
          </>
        ) : (
          <div className="flex w-full min-h-screen">
            <div className="w-full md:w-1/3 flex items-center justify-center bg-gray-100">
              <Routes>
                <Route
                  path="/login"
                  element={<Login onLogin={handleLogin} />}
                />
                <Route path="*" element={<Navigate to="/login" />} />
              </Routes>
            </div>
            <div
              className="hidden md:block w-2/3"
              style={{
                backgroundImage: `url('https://www.kayak.com.uy/rimg/himg/01/e4/d7/leonardo-646003-166923767-315817.jpg?width=968&height=607&crop=true')`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            ></div>
          </div>
        )}
      </div>
    </Router>
  );
};

const NavLink = ({ to, label }) => (
  <Link
    to={to}
    className="block p-2 bg-gray-700 rounded hover:bg-gray-600 transition md:inline-block"
  >
    {label}
  </Link>
);

export default App;
